import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d372be2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100vw"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_switch = _resolveComponent("van-switch")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "比赛设置",
      "left-arrow": "",
      "safe-area-inset-top": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.back()))
    }),
    _createVNode(_component_van_cell_group, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell, {
          center: "",
          title: "进球提示"
        }, {
          "right-icon": _withCtx(() => [
            _createVNode(_component_van_switch, {
              modelValue: $setup.jinqiu,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => (($setup.jinqiu) = $event)),
                $setup.onUpdateJinqiuValue
              ],
              loading: $setup.jinqiuLoading,
              "active-color": "#54E485",
              "inactive-color": "#DDDDDD",
              size: "24"
            }, null, 8 /* PROPS */, ["modelValue", "loading"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_van_cell, {
          center: "",
          title: "声音提示"
        }, {
          "right-icon": _withCtx(() => [
            _createVNode(_component_van_switch, {
              modelValue: $setup.sound,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => (($setup.sound) = $event)),
                $setup.onUpdateSoundValue
              ],
              loading: $setup.soundLoading,
              "active-color": "#54E485",
              "inactive-color": "#DDDDDD",
              size: "24"
            }, null, 8 /* PROPS */, ["modelValue", "loading"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_van_cell, {
          center: "",
          title: "进球动画"
        }, {
          "right-icon": _withCtx(() => [
            _createVNode(_component_van_switch, {
              modelValue: $setup.animation,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => (($setup.animation) = $event)),
                $setup.onUpdateAnimationValue
              ],
              loading: $setup.animationLoading,
              "active-color": "#54E485",
              "inactive-color": "#DDDDDD",
              size: "24"
            }, null, 8 /* PROPS */, ["modelValue", "loading"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    })
  ]))
}